addEventListener("DOMContentLoaded", _=> {
    let arrows = document.getElementsByClassName("blog-rider-arrows");

    [...arrows].forEach(arrow => {
        let left = arrow.firstElementChild;
        let right = arrow.lastElementChild;
        let box = arrow.previousElementSibling;
        let minLeft = 0;
        if(minLeft>0) arrow.style.display = none;
        window.x = box;
        arrow.shift = 0;
        let getMinLeft = _=> {
            let container = Math.min(box.parentNode.offsetWidth, 1280 - 16);
            return container - box.childElementCount * box.children[0].offsetWidth - 32;
        }
        let moving = 0;
        let dirShift = dir => {
            if(moving) return;
            moving = 1;
            setTimeout(_=>moving=0, 500);
            minLeft = getMinLeft();
            arrow.shift += dir;
            if(arrow.shift<minLeft) arrow.shift = minLeft;
            if(arrow.shift>0) arrow.shift = 0;
            if(arrow.shift==minLeft) right.classList.add("inactive"); else right.classList.remove("inactive");
            if(arrow.shift==0) left.classList.add("inactive"); else left.classList.remove("inactive");
            box.style.marginLeft = arrow.shift + "px";
        };
        left.onclick = left.ontouchstart = _=> dirShift(+425);
        right.onclick = right.ontouchstart = _=> dirShift(-425);

        // swipe
        let sx;
        box.ontouchstart = e => {
            sx = e.touches[0].pageX;
            box.classList.add("swiping");
        }
        box.ontouchmove = e => box.style.marginLeft = arrow.shift + (e.touches[0].pageX - sx) + "px";
        box.ontouchend = e => {
            minLeft = getMinLeft();
            arrow.shift = parseInt(box.style.marginLeft);
            if(arrow.shift<minLeft) arrow.shift = minLeft;
            if(arrow.shift>0) arrow.shift = 0;
            if(arrow.shift==minLeft) right.classList.add("inactive"); else right.classList.remove("inactive");
            if(arrow.shift==0) left.classList.add("inactive"); else left.classList.remove("inactive");
            box.style.marginLeft = arrow.shift + "px";
            box.classList.remove("swiping");
        }
    });
});